module.exports = __webpack_public_path__ + "img/ico21.8944da54.jpg";